import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'cs_CZ',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: true,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  'aa09278c-d227-44f9-ae1b-184996acf6e8',
  ''
);
